export default __webpack_public_path__ + "static/media/kabe_sample_thumb.f05ce64d.png";